import cx from "classnames";
import React from "react";
import Typography from "src/components/Typography";
import classes from "./styles.module.scss";
import { Props } from "./types";

const MobileProgressBar: React.FC<Props> = ({ step, title }) => {
  const renderHeaderTitle = () => {
    return "Order an Impact Test Report";
  };
  return (
    <div className={classes.progressBarMobile}>
      <Typography fontWeight="semibold" variant="p18">
        {renderHeaderTitle()}
      </Typography>
      <div className={classes.progressBar}>
        <div
          className={cx(classes.mobileBarWrapper, {
            [classes.active]: step === 1,
          })}
        >
          <div className={classes.bar}></div>
          <Typography className="mb-0 mt-1" fontWeight="semibold" variant="p10">
            Property information
          </Typography>
        </div>
        <div
          className={cx(classes.mobileBarWrapper, {
            [classes.active]: step === 2,
          })}
        >
          <div className={classes.bar}></div>
          <Typography className="mb-0 mt-1" fontWeight="semibold" variant="p10">
            Testing Parameters
          </Typography>
        </div>
        <div
          className={cx(classes.mobileBarWrapper, {
            [classes.active]: step === 3,
          })}
        >
          <div className={classes.bar}></div>
          <Typography className="mb-0 mt-1" fontWeight="semibold" variant="p10">
            Contact information
          </Typography>
        </div>
        <div
          className={cx(classes.mobileBarWrapper, {
            [classes.active]: step === 4,
          })}
        >
          <div className={classes.bar}></div>
          <Typography className="mb-0 mt-1" fontWeight="semibold" variant="p10">
            Shipping & payment
          </Typography>
        </div>
      </div>
      <Typography className="mb-0" fontWeight="bold" variant="p18">
        {step ? `Step ${step}:${title}` : "Impact Test Report"}
      </Typography>
    </div>
  );
};

export default MobileProgressBar;
